"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CareGapReasonCodeDisplay = exports.CareGapReasonCode = exports.ImprovementNotation = exports.Relevance = exports.FinalResult = exports.PopulationType = exports.AggregationType = exports.MeasureScoreType = void 0;
/**
 * Enum for measure score types. Matching http://terminology.hl7.org/CodeSystem/measure-scoring
 */
var MeasureScoreType;
(function (MeasureScoreType) {
    MeasureScoreType["PROP"] = "proportion";
    MeasureScoreType["RATIO"] = "ratio";
    MeasureScoreType["CV"] = "continuous-variable";
    MeasureScoreType["COHORT"] = "cohort";
})(MeasureScoreType = exports.MeasureScoreType || (exports.MeasureScoreType = {}));
/**
 * Enum for measure aggregation types. Matching // http://build.fhir.org/ig/HL7/cqf-measures/ValueSet-aggregate-method.html
 */
var AggregationType;
(function (AggregationType) {
    AggregationType["SUM"] = "sum";
    AggregationType["AVERAGE"] = "average";
    AggregationType["MEDIAN"] = "median";
    AggregationType["MIN"] = "minimum";
    AggregationType["MAX"] = "maximum";
    AggregationType["COUNT"] = "count";
})(AggregationType = exports.AggregationType || (exports.AggregationType = {}));
/**
 * Enum for population types. Matching http://hl7.org/fhir/valueset-measure-population.html
 */
var PopulationType;
(function (PopulationType) {
    PopulationType["IPP"] = "initial-population";
    PopulationType["DENOM"] = "denominator";
    PopulationType["DENEX"] = "denominator-exclusion";
    PopulationType["DENEXCEP"] = "denominator-exception";
    PopulationType["NUMER"] = "numerator";
    PopulationType["NUMEX"] = "numerator-exclusion";
    PopulationType["MSRPOPL"] = "measure-population";
    PopulationType["MSRPOPLEX"] = "measure-population-exclusion";
    PopulationType["OBSERV"] = "measure-observation";
})(PopulationType = exports.PopulationType || (exports.PopulationType = {}));
/**
 * Final result for a clause or statement.
 *
 * 'NA' - Not applicable. This statement is not relevant to any population calculation in this population_set. Common
 *   for unused library statements or statements only used for other population sets.
 *   !!!IMPORTANT NOTE!!! All define function statements are marked 'NA' since we don't have a strategy for
 *        highlighting or coverage when it comes to functions.
 *
 * 'UNHIT' - This statement wasn't hit. This is most likely because the statement was not relevant to population
 *     calculation for this patient. i.e. 'FALSE' in the the `statement_relevance` map.
 *
 * 'TRUE' - This statement is relevant and has a truthy result.
 *
 * 'FALSE' - This statement is relevant and has a falsey result.
 */
var FinalResult;
(function (FinalResult) {
    FinalResult["NA"] = "NA";
    FinalResult["UNHIT"] = "UNHIT";
    FinalResult["TRUE"] = "TRUE";
    FinalResult["FALSE"] = "FALSE";
})(FinalResult = exports.FinalResult || (exports.FinalResult = {}));
/**
 * 'NA' - Not applicable. This statement is not relevant to any population calculation in this population_set. Common
 *   for unused library statements or statements only used for other population sets.
 *
 * 'FALSE' - This statement is not relevant to any of this patient's population inclusion calculations.
 *
 * 'TRUE' - This statement is relevant for one or more of the population inclusion calculations.
 */
var Relevance;
(function (Relevance) {
    Relevance["NA"] = "NA";
    Relevance["TRUE"] = "TRUE";
    Relevance["FALSE"] = "FALSE";
})(Relevance = exports.Relevance || (exports.Relevance = {}));
/**
 * https://terminology.hl7.org/2.0.0/CodeSystem-measure-improvement-notation.html
 *
 * 'POSITIVE': Improvement is indicated as an increase in the score or measurement (e.g. Higher score indicates better quality).
 *
 * 'NEGATIVE': Improvement is indicated as a decrease in the score or measurement (e.g. Lower score indicates better quality).
 */
var ImprovementNotation;
(function (ImprovementNotation) {
    ImprovementNotation["POSITIVE"] = "increase";
    ImprovementNotation["NEGATIVE"] = "decrease";
})(ImprovementNotation = exports.ImprovementNotation || (exports.ImprovementNotation = {}));
/**
 * URL to be defined
 * 'NOTFOUND': Gap is detected because desired data cannot be found
 * 'MISSING': Gap is detected because data is known to exist but cannot be found
 * 'PRESENT': Gap is due to present data
 * 'INVALIDATTRIBUTE': Gap is detected because data element was found, but value was not equal to expected value
 * 'DATEINRANGE': Gap is due to a date being within a range
 * 'DATEOUTOFRANGE': Gap is due to a date being out of range
 * 'VALUEINRANGE = Gap is due to value being within a range
 * 'VALUEOUTOFRANGE': Gap is due to a value being out of range
 * 'COUNTINRANGE': Gap is due to count of data elements being within a range
 * 'COUNTOUTOFRANGE': Gap is due to a count of resources being out of range
 * 'NOTALLOWED': Data Element was not used in care gap calculation due to an external requirement
 */
var CareGapReasonCode;
(function (CareGapReasonCode) {
    CareGapReasonCode["NOTFOUND"] = "NotFound";
    CareGapReasonCode["MISSING"] = "Missing";
    CareGapReasonCode["PRESENT"] = "Present";
    CareGapReasonCode["INVALIDATTRIBUTE"] = "InvalidAttribute";
    CareGapReasonCode["DATEINRANGE"] = "DateInRange";
    CareGapReasonCode["DATEOUTOFRANGE"] = "DateOutOfRange";
    CareGapReasonCode["VALUEINRANGE"] = "ValueInRange";
    CareGapReasonCode["VALUEOUTOFRANGE"] = "ValueOutOfRange";
    CareGapReasonCode["COUNTINRANGE"] = "CountInRange";
    CareGapReasonCode["COUNTOUTOFRANGE"] = "CountOutOfRange";
    CareGapReasonCode["NOTALLOWED"] = "NotAllowed";
})(CareGapReasonCode = exports.CareGapReasonCode || (exports.CareGapReasonCode = {}));
/**
 * Lookup object for CareGapReasonCode to display text
 */
exports.CareGapReasonCodeDisplay = (_a = {},
    _a[CareGapReasonCode.NOTFOUND] = 'Data Element Not Found',
    _a[CareGapReasonCode.MISSING] = 'Missing Data Element',
    _a[CareGapReasonCode.PRESENT] = 'Data Element is Present',
    _a[CareGapReasonCode.INVALIDATTRIBUTE] = 'Attribute is Invalid',
    _a[CareGapReasonCode.DATEINRANGE] = 'Date is within specified range',
    _a[CareGapReasonCode.DATEOUTOFRANGE] = 'Date is out of specified range',
    _a[CareGapReasonCode.VALUEINRANGE] = 'Value is within specified range',
    _a[CareGapReasonCode.VALUEOUTOFRANGE] = 'Value is out of specified range',
    _a[CareGapReasonCode.COUNTINRANGE] = 'Count is within specified range',
    _a[CareGapReasonCode.COUNTOUTOFRANGE] = 'Count is out of specified range',
    _a[CareGapReasonCode.NOTALLOWED] = 'Data Element was not used in care gap calculation due to an external requirement',
    _a);
//# sourceMappingURL=Enums.js.map